/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  util.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:26
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

// @ts-ignore
import { isEmpty } from 'lodash'
import * as math from 'mathjs'
import { ACCESS_KEY_ID, ACCESS_KEY_SECRET } from '@/api/index'
import { pinyin } from 'pinyin-pro'
import { ImagePreview } from 'vant';
import { setImageWithURL } from '@/utils/h5ToApp'
import dayjs from 'dayjs'

export const downloadNetUrl = '/cykjcommodity/goodsGM/downloadFile'
export const videoServer = '/tvs/'

interface CEvent extends Event {
  eventType: string
}
/**
  * @description 用于放大v-html里面的图片内容,预览单张照片
  */
export function imagePreview(event:any) {
  let src = event.target.src
  src = src.replace(/^\S*(?=\/api)/g,'')
  if(event.target.nodeName !== 'IMG') return
  ImagePreview({images:[src]})
}

export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents') as CEvent
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader (callback: { (): void; (arg0: string): void; }) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function() { }
  window.addEventListener(
          'scroll',
          event => {
            clearTimeout(timer)
            timer = window.setTimeout(() => {
              let direction = 'up'
              const afterScrollTop = window.pageYOffset
              const delta = afterScrollTop - beforeScrollTop
              if (delta === 0) {
                return false
              }
              direction = delta > 0 ? 'down' : 'up'
              callback(direction)
              beforeScrollTop = afterScrollTop
            }, 50)
          },
          false
  )
}

export function isIE () {
  const bw = window.navigator.userAgent
  const compare = (s: string) => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

export function uuid () {
  let d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now() // use high-precision timer if available
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id)!)
  }, timeout)
}

/**
 * @description 获取分数值
 */
export function getPointValue (val: string) {
  const array = val.split('~')
  let num = 0
  array.length > 1 && (num = Number(array[0]) < 0 ? Number(array[0]) : Number(array[1]))
  return num
}

/**
 * 判断变量是否为空, '' 或 null 或 undefined
 * @param val 需要判断的变量
 * @returns {boolean}
 */
export function checkIsEmpty (val: any) {
  return typeof val === 'number' ? (val === null || val === void 0 || String(val).trim() === '') : isEmpty(val)
}

/**
 * arraybuffer转base64
 * @param buffer
 */
export function transformArrayBufferToBase64 (buffer: ArrayBuffer) {
  let binary = ''
  let bytes = new Uint8Array(buffer)
  for (let len = bytes.byteLength, i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return window.btoa(binary)
}

/**
 * 展平树结构数据
 * @param tree
 * @param childKey
 * @param list
 */
export function flattenTree<T extends { [x: string]: any } = any> (tree: T[], childKey = 'children', list: any = []): T[] {
  tree.forEach(i => {
    list.push(i)
    if (i[childKey]) {
      flattenTree(i[childKey], childKey, list)
    }
  })
  return list
}

/**
 * @param {Number、String} 数值、字符串
 * @param {Number、String } 保留位置,默认两位
 * @param {String} 货币,默认人民币
 * @description  格式化金额
 */
export function moneyFormat (value, currency = '¥', decimals = 2) {
  if (value === '' || value === null || value === undefined) {
    return '--'
  }
  let digitsRE = /(\d{3})(?=\d)/g
  value = parseFloat(value)
  if (typeof value === 'string') {
    return value
  }
  if (!isFinite(value) || (!value && value !== 0)) return ''
  let stringified = Math.abs(value).toFixed(decimals)
  let _int = decimals ? stringified.slice(0, -1 - decimals) : stringified
  let i = _int.length % 3
  let head = i > 0 ? (_int.slice(0, i) + (_int.length > 3 ? ',' : '')) : ''
  let _float = decimals ? stringified.slice(-1 - decimals) : ''
  let sign = value < 0 ? '-' : ''
  return sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float
}

/**
 * 处理金额数值（保留两位小数）
 * @param data 金额
 * @param split 分割符
 */
export function handleAmount (data: number | string | any, split = ',', precision = 2, prefix = '￥') {
  if (data === '' || data === null || data === undefined) {
    return '--'
  }
  data = typeof data === 'string' ? parseFloat(data) : data
  data = data.toFixed(precision)
  if (split === ',') return `${prefix}${(('' + data)).replace(/\B(?=(\d{3})+(?!\d))/g, split)}`
}

/**
 * 处理金额数值（保留两位小数）
 * @param data 金额
 * @param split 分割符
 */
export function handlePercentage (data: number | string | any, split = ',', precision = 2, prefix = '%') {
  if (data === '' || data === null || data === undefined) {
    return '--'
  }
  data = typeof data === 'string' ? parseFloat(data) : data
  data = (data * 100).toFixed(precision)
  if (split === ',') return `${(('' + data)).replace(/\B(?=(\d{3})+(?!\d))/g, split)}${prefix}`
}

export function handleFill (data: any) {
  return data === '' || data === null || data === undefined ? '--' : data
}

export function printFn (value: number, decimal = 2) {
  if (value === Infinity) return 0
  const precision = 14
  value = isNaN(value) ? 0 : value
  const num = Number(math.format(value * Math.pow(10, decimal), precision))
  const result = parseInt('' + num) / Math.pow(10, decimal)
  return Number(math.format(result, precision))
}

export function downloadUrl (data: string | any): string {
  if (!data) return ''
  let baseUrl = process.env.VUE_APP_MANAGE_API_BASE_URL
  if (process.env.NODE_ENV === 'production') baseUrl = ''
  return `${baseUrl}${downloadNetUrl}?filePath=${data}&access_key_id=${ACCESS_KEY_ID}&access_key_secret=${ACCESS_KEY_SECRET}`
}

export async function asyncDownloadUrl (data: string | any): Promise<string> {
  if (!data) return ''
  let res: any = await setImageWithURL(`${downloadNetUrl}?filePath=${data}`)
  return res || undefined
}

// 获取视频播放文件
export function getVideoFile (data: string | any): string {
  if (!data) return ''
  let baseUrl = process.env.VUE_APP_MANAGE_API_BASE_URL
  if (process.env.NODE_ENV === 'production') baseUrl = ''
  return `${baseUrl}${videoServer}?filePath=${data}&access_key_id=${ACCESS_KEY_ID}&access_key_secret=${ACCESS_KEY_SECRET}`
}

// 获取配送方式名称（1快递 2客户自提 3商家配送 4骑手配送 5其他）
export function getDistributionWayName (type) {
  let name
  switch (Number(type)) {
    case 1:
      name = '快递'
      break
    case 2:
      name = '客户自提'
      break
    case 3:
      name = '商家配送'
      break
    case 4:
      name = '骑手配送'
      break
    case 5:
      name = '其他'
      break
  }
  return name
}

/**
 * 生成uid
 * @returns 返回12位
 */
export function guid () {
  return 'xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    let r = Math.random() * 16 | 0
    let v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

export function toType (data: any, type: string) {
  return Object.prototype.toString.call(data).slice(8, -1) === type
}

// @ts-ignore
export function formatterMoney (value) {
  value = Number(value) > 99999999.99 ? '99999999.99' : value
  return value.replace(/[^0-9.]/g, '').replace(/^(\\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
}

// @ts-ignore
// 以万为单位，最多保留2位小数，例如23.50万
export function formatterNum (value, size,fixedSize=2) {
  return Number(value) >= 10000 ? (Number(value) / 10000).toFixed(fixedSize) + `<span style="font-size: ${size}px;">万</span>` : Number(value)
}

// 汉字转字母
export function getPinyin (name: string, options: any) {
  return pinyin(name, options).toUpperCase().replace(/\s*/g, '')
}

/**
 * 函数名：calculateDistance
 * 函数功能：根据两点经纬度计算距离
 * @param latitude1 第一个点的纬度，类型为数字
 * @param longitude1 第一个点的经度，类型为数字
 * @param latitude2 第二个点的纬度，类型为数字
 * @param longitude2 第二个点的经度，类型为数字
 * @returns 返回两点之间的距离，单位为千米
 */
export function calculateDistance (latitude1: number, longitude1: number, latitude2: number, longitude2: number) {
  const EARTH_RADIUS = 6378.137// 地球半径
  const radLat1 = latitude1 * Math.PI / 180.0 // latitude1 * Math.PI / 180.0=>弧度计算
  const radLat2 = latitude2 * Math.PI / 180.0
  const a = radLat1 - radLat2
  const b = longitude1 * Math.PI / 180.0 - longitude2 * Math.PI / 180.0
  let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)))
  s = s * EARTH_RADIUS
  s = Math.round(s * 10000) / 10000// 输出为公里
  return Number(s.toFixed(2))
}

/**
 * @description: 保留n位小数（不进位）处理精度丢失问题
 * @param {number} value 数据
 * @param {number} num 保留小数位
 * @return {number}
 */
// @ts-ignore
export function keepDecimal (value: number, num = 1) {
  let step = num
  num += 2
  let data = String(value).split('.')
  if (data.length > 1) {
    let decimal = data[1]
    if (decimal.length < num) {
      for (let i = 0; i < num - decimal.length; i++) {
        decimal = decimal + '0'
      }
    }
    return Number(`${data[0]}.${decimal.slice(0, num)}`).toFixed(step)
  } else {
    let decimal = ''
    for (let i = 0; i < num; i++) {
      decimal = decimal + '0'
    }
    return Number(`${value}.${decimal}`).toFixed(step)
  }
}

/**
 * @description: 活动计算当前时间是否
 * @param {object} activityData 数据
 * @return {object}
 */
export function getIsAfterTime (activityData: any) {
  const data = {
    isAfterAdvance: false, // 是否过了显示时间
    isAfterBegin: false, // 是否过了开始时间
    isAfterEnd: false // 是否过了结束时间
  }
  if (activityData.timeType) { // 自定义时间段
    // 显示时间
    const subtractTime = dayjs(activityData.beginTime).subtract(activityData.advanceTime || 0, 'minutes')
    data.isAfterAdvance = dayjs().isAfter(subtractTime)
    data.isAfterBegin = dayjs().isAfter(dayjs(activityData.beginTime))
    data.isAfterEnd = dayjs().isAfter(dayjs(activityData.closeTime))
    console.log('自定义时间段 000***', data.isAfterAdvance, data.isAfterBegin, data.isAfterEnd)
  } else { // 每天时间段
    // 开始时间
    const startString = `${dayjs().format('YYYY-MM-DD')} ${activityData.startTime}`
    // 显示时间
    const subtractTime = dayjs(startString).subtract(activityData.advanceTime || 0, 'minutes')
    data.isAfterAdvance = dayjs().isAfter(subtractTime)
    data.isAfterBegin  = dayjs().isAfter(`${dayjs().format('YYYY-MM-DD')} ${activityData.startTime}`)
    data.isAfterEnd = dayjs().isAfter(`${dayjs().format('YYYY-MM-DD')} ${activityData.endTime}`)
    console.log('每天时间段 111***', data.isAfterAdvance, data.isAfterBegin, data.isAfterEnd)
  }
  return data
}

/**
 * 精确计算浮动小数的加减乘除运算，避免浮点数计算精度问题。
 * @param {number} num1 - 第一个数字。
 * @param {number} num2 - 第二个数字。
 * @param {string} type - 运算类型，支持 'add' (加法), 'subtract' (减法), 'multiply' (乘法), 'divide' (除法)，默认为 'add'。
 * @returns {number} - 运算结果。
 */
export function decimalPrecision1 (num1: number, num2: number, type = 'add') {
  const decimalLen1 = num1.toString().split('.')[1]?.length || 0
  const decimalLen2 = num2.toString().split('.')[1]?.length || 0
  const factor1 = Math.pow(10, decimalLen1)
  const factor2 = Math.pow(10, decimalLen2)
  const maxFactor = Math.max(factor1, factor2)
  switch (type) {
    case 'add': // 加法
      return ((num1 * maxFactor) + (num2 * maxFactor)) / maxFactor
    case 'subtract': // 减法
      return ((num1 * maxFactor) - (num2 * maxFactor)) / maxFactor
    case 'multiply': // 乘法
      num1 = Number(String(num1).replace('.', ''))
      num2 = Number(String(num2).replace('.', ''))
      return num1 * num2 / Math.pow(10, decimalLen1 + decimalLen2)
    case 'divide': // 除法
      if (num2 === 0) {
        console.log(new Error('Division by zero'))
        return 0
      }
      num1 = Number(String(num1).replace('.', ''))
      num2 = Number(String(num2).replace('.', ''))
      // return (num1 * factor1) / (num2 * factor2) / Math.pow(10, decimalLen1 - decimalLen2)
      return num1 / num2 / Math.pow(10, decimalLen1 - decimalLen2)
    default:
      throw new Error('Invalid operation type')
  }
}

export function decimalPrecision (num1: number, num2: number, type = 'add') {
  const arr1 = num1.toString().split('.')
  const arr2 = num2.toString().split('.')
  const decimalLen1 = arr1[1]?.length || 0
  const decimalLen2 = arr2[1]?.length || 0
  const maxDecimalLen = Math.max(decimalLen1, decimalLen2)
  const maxFactor = Math.pow(10, maxDecimalLen)
  console.log(maxDecimalLen)
  if (maxDecimalLen !== 0) {
    console.log('num2', decimalLen1)
    if (decimalLen1 !== maxDecimalLen) {
      for (let i = decimalLen1; i < maxDecimalLen; i++) {
        if (!arr1[1]) { 
          arr1[1] = '0'
        } else {
          arr1[1] += '0'
        }
      }
      console.log('arr1', arr1[0], arr1[1])
      num1 = Number(arr1[0] + arr1[1])
      console.log('num1', num1)
    } else {
      num1 = Number(arr1[0] + arr1[1])
      console.log('else-num1', num1)
    }
    if (decimalLen2 !== maxDecimalLen) {
      for (let i = decimalLen2; i < maxDecimalLen; i++) {
        if (!arr2[1]) { 
          arr2[1] = '0'
        } else {
          arr2[1] += '0'
        }
      }
      console.log('arr2', arr2[0], arr2[1])
      num2 = Number(arr2[0] + arr2[1])
      console.log('num2', num2)
    } else {
      num2 = Number(arr2[0] + arr2[1])
      console.log('else-num2', num2)
    }
  }
  console.log(num1, num2)
  switch (type) {
    case 'add': // 加法
      return (num1 + num2) / maxFactor
    case 'subtract': // 减法
      return (num1 - num2) / maxFactor
    case 'multiply': // 乘法
      return num1 * num2 / maxFactor / maxFactor
    case 'divide': // 除法
      if (num2 === 0) {
        console.log(new Error('Division by zero'))
        return 0
      }
      return num1 / num2
    default:
      throw new Error('Invalid operation type')
  }
}
